import React from 'react';
const LoadingSpinnerImage = ({ small = false }) => {
    return (
        <img src="/assets/js/frontend/public/loading-spinner.gif" style={small ? { width: "15px"} : null} alt="Loading..." />
    );
};

export default LoadingSpinnerImage;
